<template>
  <div>
      <b-alert v-if="error" class="danger-alert" :show="dismissCountDown" dismissible fade variant="danger" @dismissed="dismissCountDown = 0; error = '';" @dismiss-count-down="countDownChanged">
          <h4>{{ error }}</h4>
      </b-alert>

      <b-alert v-if="success" class="success-alert" :show="dismissCountDown" dismissible fade variant="danger" @dismissed="dismissCountDown = 0; success = '';" @dismiss-count-down="countDownChanged">
          <h4>{{ success }}</h4>
      </b-alert>
  </div>
</template>

<script>
import EventBus from '@/services/EventBus'

export default {
    data() {
        return {
            dismissSeconds: 5,
            dismissCountDown: 0,
            error: '',
            success: ''
        }
    },
    mounted() {
        EventBus.$on('Success', (success) => {
          this.success = success;

          this.showAlert();
        })

        EventBus.$on('Error', (error) => {
            if(error.response !== undefined) {
                if (error.response.status === 500) {
                    if ('data' in error.response) {
                        this.error = error.response.data
                    } else {
                        this.error = 'Oops. Something went wrong!'
                    }
                } else if(error.response.status === 401) {
                    return
                }
            } else {
                this.error = 'Oops. Something went wrong!'
            }
            this.showAlert();
        })
    },
    computed: {
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert() {
            this.dismissCountDown = this.dismissSeconds
        }
    },
    watch: {
        $route (to, from){
            this.dismissCountDown = 0;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Stock/Errors.vue